import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-annuler-devis-negoce',
  templateUrl: './annuler-devis-negoce.component.html',
  styleUrls: ['./annuler-devis-negoce.component.scss']
})
export class AnnulerDevisNegoceComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
